import { render, staticRenderFns } from "./MenuForm.vue?vue&type=template&id=304d6175&scoped=true"
import script from "./MenuForm.vue?vue&type=script&lang=js"
export * from "./MenuForm.vue?vue&type=script&lang=js"
import style0 from "./MenuForm.vue?vue&type=style&index=0&id=304d6175&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304d6175",
  null
  
)

export default component.exports